<template>
  <div>
    <div class="modal-pdv modal-full" id="modalPedido" tabindex="-1" :class="{'show': modal}">
      <div class="modal-pdv-content" v-if="modal">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-7">
              <div class="border rounded px-2 py-1 d-flex justify-content-between align-items-center mb-2 bg-light">
                <h6 class="mb-0" v-if="comanda.tipo_comanda === '1'">Mesa: <b>{{ comanda.mesa }}</b></h6>
                <h6 class="mb-0" v-if="comanda.tipo_comanda === '2'"><b>Delivery</b></h6>
                <h6 class="mb-0" v-if="comanda.tipo_comanda === '3'">Comanda: <b>{{ comanda.ref_comanda }}</b></h6>
                <h6 class="mb-0" v-if="comanda.tipo_comanda === '5'"><b>Balcão</b></h6>
                <div><button class="btn btn-sm text-secondary" @click="limparProdutos()" :disabled="!dados.produtos.length">Limpar Pedido</button></div>
              </div>
              <div class="d-none d-lg-flex justify-content-between align-items-center mb-2">
                <input class="form-control" id="pesquisaPedido" placeholder="Pesquisar nome ou código do produto" v-model="termo" @keyup.enter="pesquisarTermo(termo)">
                <div class="pl-1">
                  <button class="btn btn-primary text-nowrap" @click="pesquisarProduto()" @keydown.tab="nextPedido()"><i class="fa fa-list-alt"></i> Produtos</button>
                </div>
              </div>
              <div class="border height-90 mb-2 rounded" style="min-height: 180px!important;">
                <table class="table table-sm mb-0">
                  <tr class="small bg-light">
                    <th class="r-pedido p-0 border-0">&nbsp;</th>
                    <th class="text-left p-0 border-0"></th>
                    <th class="p-0 d-none d-sm-table-cell border-0" style="width: 140px">&nbsp;</th>
                  </tr>
                  <tr v-for="(p, index) in dados.produtos">
                    <td class="text-center" @click="removerProduto(p, index)">
                      <a href="javascript:"><i class="fa fa-trash-alt small text-danger pointer"></i></a>
                    </td>
                    <td @click="editarProduto(p)" class="text-left pointer">
                      <b v-show="p.produto.id_medida !== '2'">{{p.quantidade}}x</b>
                      <b v-show="p.produto.id_medida === '2'">{{p.quantidade | medida}}</b>
                      {{p.produto.nome_produto}}
                      <span v-show="p.produto.nome_tabela"><b>{{p.produto.nome_tabela}}</b></span>
                      <a href="javascript:" v-if="!p.id_comanda_produto"><i class="fa fa-edit small text-primary"></i></a>
                      <div v-for="d in p.divisoes">
                        # {{d.nome_produto}}
                      </div>
                      <div v-for="a in p.adicionais">
                        + {{a.quantidade | qtdAdc}} {{a.nome_produto}} <span v-show="a.valor > 0">- R$ {{a.valor * a.quantidade | valor}}</span>
                      </div>
                      <div v-show="p.observacao">
                        Obs: <b>{{p.observacao}}</b>
                      </div>
                      <div>
                        Total: <b>R$ {{p.valor_total | valor}}</b>
                        <span class="badge badge-warning ml-2" title="O desconto deste voucher será aplicado no finalizar venda" v-if="p.id_voucher">
                          <i class="fa fa-ticket-alt mr-1"></i> Voucher
                        </span>
                      </div>
                    </td>
                    <td class="text-right align-middle d-none d-sm-table-cell">
                      <div v-if="p.produto.id_medida === '2'">
                        <money class="form-control" v-model="p.valor_total" @blur.native="alterarPeso(p)"/>
                      </div>
                      <div class="d-flex justify-content-between border rounded-sm" v-else>
                        <button class="btn" @click="minusQtd(p, index)">
                          <i class="fa fa-minus"></i>
                        </button>
                        <div style="font-weight: bold; padding: 6px">{{p.quantidade}}</div>
                        <button class="btn text-primary" @click="plusQtd(p)">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="d-lg-none mb-3">
                <button class="btn btn-outline-dark btn-block py-3 px-4" @click="pesquisarProduto()">
                  <i class="fa fa-plus mr-2"></i> Adicionar Produtos
                </button>
              </div>
            </div>
            <div class="col-md-5">
              <div class="mb-2" v-if="!comanda.id_comanda && comanda.tipo_comanda === '2' && cliente.id_cliente">
                <label class="mb-0 small font-weight-bold">Cliente<span v-if="cliente.id_cliente">: {{cliente.nome_cliente}}</span></label>
                <div class="d-flex justify-content-between align-items-center">
                  <the-mask :mask="['(##) ####-####', '(##) #####-####']" class="form-control" placeholder="(##) #####-###" minlength="8"
                            v-model="telefone" @keyup.native.enter.prevent="buscarClientes()" :disabled="cliente.id_cliente"/>
                  <div class="text-nowrap ml-2">
                    <button class="btn btn-third" style="width: 80px" title="Buscar cliente" @click="buscarClientes()">
                      <i class="fa fa-search" v-show="!cliente.id_cliente"></i>
                      <i class="fa fa-edit" v-show="cliente.id_cliente"></i>
                    </button>
                    <button v-show="cliente.id_cliente" class="btn btn-secondary ml-1" style="width: 80px" @click="removerCliente()">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
                <hr>
              </div>
              <div class="mb-2">
                <label class="mb-1" v-if="comanda.tipo_comanda === '2'">Entregar ou retirar pedido?</label>
                <label class="mb-1" v-else>Consumir no local ou pra viagem?</label>
                <div class="row no-gutters">
                  <div class="col-6 p-1" v-if="comanda.tipo_comanda === '2'">
                    <button class="btn btn-block py-3 text-nowrap" id="btnEntregar" :class="dados.tipo_pedido === '1' ? 'btn-info' : 'border'" @click="toggleTipoPedido('1')">Entregar Pedido</button>
                  </div>
                  <div class="col-6 p-1" v-else>
                    <button class="btn btn-block py-3 text-nowrap" id="btnConsumo" :class="dados.tipo_pedido === '3' ? 'btn-info' : 'border'" @click="toggleTipoPedido('3')">Consumir no Local</button>
                  </div>
                  <div class="col-6 p-1">
                    <button class="btn btn-block py-3 text-nowrap" id="btnRetirar" :class="dados.tipo_pedido === '2' ? 'btn-info' : 'border'" @click="toggleTipoPedido('2')">
                      {{ comanda.tipo_comanda === '2' ? 'Retirar Pedido' : 'Para Viagem' }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="mb-2" v-if="!comanda.id_comanda">
                <div class="mt-3 mb-1" v-if="comanda.tipo_comanda === '2'">
                  <a href="javascript:" class="badge border border-dark p-2 pointer text-primary mr-2" @click="toggleObsPedido('Pedido pago ')">Pedido pago <i class="fa fa-plus ml-1"></i></a>
                  <a href="javascript:" class="badge border border-dark p-2 pointer text-primary" @click="toggleObsPedido('Sem troco ')">Sem troco <i class="fa fa-plus ml-1"></i></a>
                </div>
                <div v-else-if="comanda.tipo_comanda !== '5'">
                  <div class="row no-gutters">
                    <div class="col-md-6 mb-2" v-if="comanda.tipo_comanda === '1'">
                      <label class="mb-0 small font-weight-bold">Vincular comanda</label>
                      <div class="input-group">
                        <input type="number" class="form-control" v-model="ref_comanda" placeholder="Comanda" disabled/>
                        <div class="input-group-append" style="width: 62px">
                          <button v-if="!ref_comanda" class="btn btn-warning btn-block text-nowrap" title="Consultar Comandas" @click="openModaComandas()">
                            <i class="fa fa-search"></i>
                          </button>
                          <button class="btn btn-outline-dark btn-block text-nowrap" title="Desvincular Comandas" @click="ref_comanda = ''" v-else>
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-2" v-else-if="comanda.tipo_comanda === '3'">
                      <label class="mb-0 small font-weight-bold"><i class="fa fa-qrcode text-secondary"></i> Vincular mesa</label>
                      <input type="number" class="form-control" v-model="mesa" placeholder="Informe o número da mesa. Ex: 10"/>
                    </div>
                    <div class="col-md-6 mb-2 pl-md-2">
                      <label class="mb-0 small font-weight-bold">Qtd de pessoas</label>
                      <div class="d-flex">
                        <input type="number" class="form-control mr-2" v-model="qtd_pessoas" @change="changeQtdPessoas(null)" placeholder="Quantidade" min="1" max="256"/>
                        <div class="d-md-none text-nowrap">
                          <button class="btn btn-primary mr-1" @click="changeQtdPessoas(-1)" style="width: 62px">
                            <i class="fa fa-minus"></i>
                          </button>
                          <button class="btn btn-primary" @click="changeQtdPessoas(1)" style="width: 62px">
                            <i class="fa fa-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <label class="small mb-0 font-weight-bold">Observações da venda</label>
                <textarea id="obsComanda" class="form-control border-dark" rows="2"
                          :placeholder="comanda.tipo_comanda === '1' ? 'Ex: Nome do cliente' : 'Ex: Identificação do pedido'"
                          v-model="dados.obs_comanda" style="resize: none"></textarea>
              </div>
              <div class="mb-2">
                <label class="small mb-0 font-weight-bold">Observações do pedido</label>
                <textarea id="obsPedido" class="form-control border-dark" placeholder="Ex: Não enviar maionese, sem milho.." rows="2"
                          v-model="dados.obs_pedido" style="resize: none" @blur="$helpers.focusElement('btnFinalizarPedido')"></textarea>
              </div>
              <div class="d-flex justify-content-between px-2 py-2 align-items-center border rounded">
                <div class="h6 m-0">Total Pedido</div>
                <div class="h6 m-0 font-weight-bold">R$ {{total | valor}}</div>
              </div>
              <div class="mt-1">
                <span class="badge badge-secondary mr-1" title="Voucher" v-for="p in dados.pagamentos">
                  <i class="fa fa-ticket-alt mx-1"></i> {{p.observacao}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 mt-2 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="voltar()">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button class="btn btn-success p-3" id="btnFinalizarPedido" :disabled="dados.produtos.length === 0"
                  @keydown.tab="$helpers.focusElement('pesquisaPedido')"
                  @click="finalizarPedido">
            <span v-if="comanda.tipo_comanda === '2'">
              Avançar <i class="fa fa-chevron-right ml-2"></i>
            </span>
            <span v-else>
              <i class="fa fa-check mr-1"></i>
              {{ editar ? 'Editar' : 'Finalizar' }} pedido
            </span>
          </button>
        </div>
      </div>
    </div>

    <pesquisar-produto ref="pedidoPesquisa" @addVoucher="addVoucher" @atualizarPedidos="atualizarPedidos" @cancelar="dados.produtos.length ? toggleModal(true) : $helpers.focusElement('pesquisar')"/>
    <detalhes-produto ref="pedidoProdDetalhe" pedido="true" @atualizarProduto="atualizarProduto" @voltarDetalhes="voltarDetalhes()"/>
    <cliente ref="pedidoCliente" @remover="cliente = {}" @retorno="inserirCliente"/>
    <finalizar ref="pedidoFinalizar" :comanda="comanda" :totalComanda="total" @atualizarPedido="inserirPagamento" @cancelar="voltarFinalizar"/>

    <div class="modal-pdv" :class="{'show': modalComandas}">
      <div class="modal-pdv-content p-0">
        <div class="container-fluid px-0">
          <div class="px-3 pt-3">
            <h6 class="font-weight-bold mb-3 text-center text-dark">Vincular comanda</h6>
            <div class="mb-3">
              <input type="number" class="form-control" placeholder="Informe o número da comanda. Ex: 123" v-model="term_comanda" id="termComanda"
                     @keyup.enter="selComanda(term_comanda)" :disabled="load">
            </div>
          </div>
          <div class="height-90 lista-comandas p-2 border-top">
            <loading v-if="load"/>
            <div v-else>
              <div class="row no-gutters">
                <div class="col-4 p-1" v-for="c in comandas">
                  <a href="javascript:" class="btn btn-block text-left py-3 btn-success" @click="selComanda(c)">
                    <h6 class="mb-0 text-ellipsis font-weight-bold">{{c}}</h6>
                    <div class="text-ellipsis small">Comanda</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 d-flex justify-content-between">
          <button type="button" class="btn btn-outline-dark p-3" @click="modalComandas = null" style="width: 114px">
            Fechar
          </button>
          <button type="button" class="btn btn-outline-success p-3" @click="selComanda(term_comanda)" v-show="term_comanda" style="width: 114px">
            Vincular
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PesquisarProduto from "./PesquisarProduto"
  import DetalhesProduto from "./DetalhesProduto"
  import ValidarVoucher from "@/views/comanda/pdv/ValidarVoucher";
  import Loading from "@/components/gestor/loading";

  export default {
    name: "Pedido",
    components: {Loading, ValidarVoucher, PesquisarProduto, DetalhesProduto},
    props: ['comanda'],
    data() {
      return {
        modal: false,
        token: localStorage.getItem('key'),
        empresa: localStorage.getItem('token'),
        produtoEditar: {},
        cliente: {},
        telefone: '',
        pedido: null,
        editar: null,
        termo: '',
        mesa: null,
        ref_comanda: null,
        qtd_pessoas: '',

        dados: {
          produtos: [],
          id_comanda: '',
          tipo_pedido: 3,
          obs_pedido: '',
          obs_comanda: '',
          frete: 0,
          comanda: {},
          pagamentos: []
        },

        total: 0.00,

        voucher: {},
        money: {
          decimal: '.',
          thousands: '',
          prefix: 'Kg ',
          suffix: '',
          precision: 3,
          masked: false
        },

        load: false,
        term_comanda: '',
        modalComandas: false,
        comandasBd: [],
        comandas: []
      }
    },

    methods: {
      toggleModal(n, focus) {
        this.modal = n;
        this.$nextTick(() => {
          this.$helpers.toggleModal(n, 'modalPedido', this.voltar);

          if (!this.modal) {
            this.$helpers.focusElement('pesquisar');

          } else if (focus) {
            this.$helpers.focusElement('pesquisaPedido');
          }
        });
      },

      voltarFinalizar() {
        this.toggleModal(true, true);
        this.$helpers.focusElement('pesquisaPedido');
      },

      voltar() {
        if (!this.editar && this.dados.produtos.length) {
          this.$swal({
            title: '',
            text: 'Deseja cancelar este pedido ?',
            buttons: ['Não','Sim'],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.toggleModal(false);
            } else {
              this.$helpers.focusElement('pesquisaPedido');
            }
          })

        } else {
          this.toggleModal(false);
        }
      },

      limparProdutos() {
        if (this.dados.produtos.length) {
          this.$swal({
            title: '',
            text: 'Deseja limpar este pedido?',
            buttons: ['Não','Sim'],
            dangerMode: true
          }).then((r) => {
            if (r) {
              this.dados.produtos = [];
              this.totalizar();
              this.pesquisarProduto();
            }
          })
        }
      },

      editarProduto(p) {
        this.produtoEditar = p;
        this.$refs.pedidoProdDetalhe.editarProduto(p);
      },

      editarPedido(p) {
        this.editar =  true;
        const produtos = p.itens.map(item => {
          if (item.adicionais && item.adicionais.length) {
            item.adicionais.forEach((adc) => {
              adc.quantidade = (adc.quantidade / item.quantidade).toFixed();
            });
          }

          return {
            adicionais: item.adicionais,
            divisoes: item.divisao,
            desconto: item.desconto,
            id_tabela_preco: item.id_tabela_preco,
            id_comanda_produto: item.id_comanda_produto,
            observacao: item.observacao,
            frete: item.frete,
            produto: {
              nome_produto: item.nome_produto,
              valor: item.valor,
              tipo_venda: item.tipo_venda,
              id_medida: item.id_medida,
              id_produto: item.id_produto,
              id_tabela_preco: item.id_tabela_preco
            },
            quantidade: item.id_medida === '1' ? parseFloat(item.quantidade || '0').toFixed(0) : item.quantidade,
            valor_total: item.valor_total
          }
        });

        this.dados = {
          produtos: produtos,
          pagamentos: [],
          id_comanda: p.id_comanda,
          id_pedido: p.id_pedido,
          tipo_pedido: p.tipo_pedido,
          obs_pedido: p.obs_pedido,
          obs_comanda: p.obs_comanda,
          frete: parseFloat(p.frete || '0'),
          cliente: p.id_cliente,
          comanda: {
            id_comanda: p.comanda.id_comanda,
            tipo_comanda: p.comanda.tipo_comanda,
            id_cliente: p.comanda.id_cliente,
            desconto: p.comanda.desconto,
            troco: p.comanda.troco,
          }
        };

        this.totalizar();
        this.toggleModal(true, true);
      },

      removerProduto(p, index) {
        this.dados.produtos.splice(index, 1);
        this.totalizar();

        if (p.id_voucher) {
          this.dados.pagamentos = this.dados.pagamentos.filter(pag => pag.id_voucher !== p.id_voucher);
        }

        this.$helpers.focusElement('pesquisaPedido');
      },

      atualizarPedidos(lista, finalizar) {
        let diversos = null;

        lista.forEach(p => {
          if (p.id_voucher && !this.addVoucher(p.voucher, false, p.produto.valor)) {
            return;
          }

          if (p.id_tabela_preco === 'REF001') {
            diversos = p;
          }

          this.dados.produtos.unshift(p);
        });

        this.termo = "";
        this.totalizar();
        this.toggleModal(true);
        this.$nextTick(() => {
          if (!diversos) {
            this.$helpers.focusElement('pesquisaPedido');

            if (finalizar && this.dados.produtos.length) {
              this.finalizarPedido();
            }

          } else {
            this.editarProduto(diversos);
          }
        });
      },

      atualizarProduto(p, edicao) {
        this.toggleModal(true);

        if (edicao) {
          const index = this.dados.produtos.indexOf(this.produtoEditar);

          if (index >= 0) {
            this.dados.produtos[index] = p;
          }

          this.totalizar()

        } else {
          this.produtoEditar = {};
        }
      },

      voltarDetalhes() {
        this.toggleModal(true);
        this.$helpers.focusElement('pesquisaPedido');
      },

      pesquisarTermo(termo) {
        if (termo && termo.trim()) {
          this.pesquisarProduto({ valor: termo }, !isNaN(termo));
          this.termo = '';

        } else if (this.configs.priorizar_codigo !== '1') {
          this.pesquisarProduto();
        }
      },

      pesquisarProduto(valor, selecionar, input) {
        this.$refs.pedidoPesquisa.pesquisarProduto((valor || null), !!selecionar, (res) => {
          if (!res) {
            this.$swal('Código não encontrado').then(() => {
              this.$helpers.focusElement(input || 'pesquisaPedido');
            });
          }
        });
      },

      toggleTipoPedido(tipo) {
        this.dados.tipo_pedido = tipo;
        this.$helpers.focusElement(!this.comanda.id_comanda ? 'obsComanda' : 'obsPedido');
      },

      toggleObsPedido(obs) {
        this.dados.obs_comanda += obs;
        this.$helpers.focusElement('obsComanda');
      },

      finalizarPedido() {
        if (this.comanda.tipo_comanda === '4') {
          this.$swal('Venda rápida não permite criação de pedido.');
          return;
        }

        this.dados.comanda = {
          id_comanda: this.comanda.id_comanda || null,
          tipo_comanda: this.comanda.tipo_comanda || null,
          id_cliente: this.comanda.id_cliente || null,
          desconto: this.comanda.desconto || 0,
          troco: this.comanda.troco || 0,
          pedido_delivery: this.comanda.pedido_delivery || null,
          mesa: this.comanda.mesa || this.mesa,
          ref_comanda: this.comanda.ref_comanda || this.ref_comanda,
          qtd_pessoas: parseInt(this.comanda.qtd_pessoas || this.qtd_pessoas || '0')
        };

        if (this.comanda.tipo_comanda === '2') {
          if (!this.comanda.id_comanda && !this.cliente.id_cliente) {
            this.buscarClientes(true);

          } else {
            this.toggleModal(false);
            this.$refs.pedidoFinalizar.finalizarPedido(this.dados);
          }

        } else {
          this.insertPedido()
        }
      },

      insertPedido() {
        if (this.dados.pagamentos.length) {
          let achou = true;
          let voucher = {};

          this.dados.pagamentos.forEach(pag => {
            voucher = pag;

            if (voucher.id_voucher) {
              achou = this.validarPedidoProduto(voucher.id_tabela_preco);
            }
          });

          if (!achou) {
            this.$swal(`Para adicionar este Voucher você precisa ter o produto: *${voucher.observacao}*, adicionado neste pedido.`);
            return;
          }
        }

        if (this.cliente.id_cliente) {
          this.dados.comanda.id_cliente = this.cliente.id_cliente;
        }

        this.dados.origin_pdv = true;
        this.dados.id_catalogo = this.id_catalogo;
        this.$store.state.load = true;

        this.$http.post("pdv/pedido/" + this.token, this.dados)
          .then(async res => {
            this.$store.state.load = false;
            const id_pedido = res.data?.id_pedido || null;
            const tipo_comanda = this.comanda.tipo_comanda;

            if (!id_pedido) {
              console.log(res);
              throw new Error('Resposta inválida do servidor');
            }

            this.toggleModal(false);
            this.$socket.emit('comanda_order', { token: this.empresa, content: { id_pedido, tipo_comanda } });
            this.pedido = res.data;

            const { id_comanda, cozinhas } = res.data;
            const title = this.editar ? "Pedido editado" : "Pedido realizado";

            await this.processarImpressao(id_pedido, id_comanda, cozinhas, title);

          }, res => {
            console.log(res);
            this.modal = true;
            this.$store.state.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      // processar impressão
      async processarImpressao(id_pedido, id_comanda, cozinhas, title) {
        await this.$nextTick();

        const temCozinha = cozinhas && Array.isArray(cozinhas) && cozinhas.length > 0;

        // Na estrutura nova, o backend seleciona as regras aplicáveis ao pedido.
        if (this.print_auto === '1' && (this.usaNovaImpressao || temCozinha)) {
          document.dispatchEvent(new CustomEvent('logInfo', {
            detail: `Impressão automática para pedido: ${id_pedido}`
          }));

          await this.solicitarImpressao(id_pedido, id_comanda);
          return;
        }

        // Nunca imprimir
        if (this.print_auto === '2') {
          this.retornarPedido(id_comanda);
          return;
        }

        // Todos os outros casos: pergunta se imprime
        const result = await this.$swal({
          text: `${title} com sucesso!\nDeseja imprimir?`,
          buttons: ['Não', 'Sim'],
          closeOnClickOutside: false
        });

        if (result) {
          await this.solicitarImpressao(id_pedido, id_comanda);

        } else {
          this.retornarPedido(id_comanda);
        }
      },

      solicitarImpressao(id_pedido, id_comanda) {
        this.$store.state.load = true;

        if (this.usaNovaImpressao) {
          this.$http.post('v2/impressao/pdv-pedido', { id_pedido })
            .then((res) => {
              this.$store.state.load = false;
              const data = res.data || {};
              const id_impressao = data.id_impressao || null;

              if (!data.success || !id_impressao) {
                this.$swal(data.erro || data.msg || 'Não foi possível imprimir este pedido, por favor tente novamente.');
                this.retornarPedido(id_comanda);
                return;
              }

              const ids = data.ids_impressao && data.ids_impressao.length ? data.ids_impressao : [id_impressao];
              if (!this.printServer) this.$store.commit('acompanharImpressaoRemota', ids);

              this.retornarPedido(id_comanda);

            }, (res) => {
              console.log(res);
              this.$store.state.load = false;
              this.$swal(res.data?.erro || res.data?.msg || 'Erro temporário');
            });
          return;
        }

        const imprimir = this.isElectron || !this.impressora.mobilePrint;
        const showValor = this.configs.show_valor === '1' || this.comanda.tipo_comanda === '2';

        this.$http.get(`comprovante/pedido/${this.empresa}/${id_pedido}`, { params: { imprimir, showValor } })
          .then(res => {
            this.$store.state.load = false;
            const id_impressao = res.data?.id_impressao || null;

            if (imprimir && !id_impressao) {
              this.$swal('Não foi possível imprimir este pedido, por favor tente novamente.');
              this.retornarPedido(id_comanda)
              return;
            }

            if (imprimir) {
              this.$helpers.awaitImpressao(this, id_impressao, 10000, 1);

            } else {
              this.$helpers.popUpimpressao(res.data);
            }

            this.retornarPedido(id_comanda);

          }, res => {
            console.log(res);
            this.$store.state.load = false;
            this.$swal(res.data?.msg || 'Erro temporário');
          });
      },

      retornarPedido(id_comanda) {
        if ((this.is_mobile || (this.local.mostrar_comanda === '1')) && ['1','3'].includes(this.comanda.tipo_comanda)) {
          const url = '/pdv?' + (this.comanda.tipo_comanda === '1' ? 'novaMesa=true' : 'novaComanda=true');
          this.$router.push(url);

        } else if (!this.comanda.id_comanda) {
          let url = '/pdv/' + id_comanda;

          if (this.comanda.tipo_comanda === '5' && this.usuario.id_funcao < 3) {
            url += '?finalizar=true';
          }

          this.$router.push(url);

        } else {
          this.$emit('retorno');
        }
      },

      buscarClientes(finalizar) {
        this.toggleModal(false);
        this.$refs.pedidoCliente.iniciar(this.cliente.id_cliente, finalizar);
      },

      removerCliente() {
        this.cliente = {};
        this.telefone = '';
        this.$helpers.focusElement('pesquisaPedido');
      },

      inserirCliente(dados, finalizar) {
        this.toggleModal(true);

        if (dados) {
          this.cliente = {
            id_cliente: dados.id_cliente,
            nome_cliente: dados.nome_cliente,
            endereco: dados.endereco,
            numero: dados.numero,
            bairro: dados.bairro,
            telefone: dados.telefone
          };

          this.telefone = dados.telefone;
          this.dados.id_cliente = dados.id_cliente;
          this.dados.id_zona = dados.id_zona;
        }

        if (finalizar) {
          this.$refs.pedidoFinalizar.finalizarPedido(this.dados);

        } else {
          this.$helpers.focusElement('obsPedido');
        }
      },

      inserirPagamento(dados) {
        this.toggleModal(true, true);
        this.dados.pagamentos = dados.pagamentos;
        this.dados.comanda.desconto = dados.desconto;
        this.dados.comanda.troco = dados.troco;
        this.dados.id_zona = dados.id_zona;
        this.dados.frete = dados.frete;

        if (dados.id_cliente) {
          this.dados.comanda.id_cliente = dados.id_cliente;
        }

        this.insertPedido();
      },

      limparPedido() {
        this.dados = {
          produtos: [],
          pagamentos: [],
          tipo_pedido: '3',
          obs_pedido: '',
          obs_comanda: '',
          frete: 0,
          comanda: {}
        };

        this.mesa = null;
        this.ref_comanda = null;
        this.qtd_pessoas = '';
        this.telefone = '';
        this.cliente = {};
        this.termo = "";
      },

      totalizar() {
        this.total = 0.00;
        if (this.dados.produtos.length > 0) {
          this.dados.produtos.forEach((p) => {
            this.total += parseFloat(p.valor_total);
          });
        }
      },

      plusQtd(p) {
        p.quantidade++;
        this.totalizarProduto(p);
      },

      minusQtd(p, index) {
        // if (p.quantidade > 1 && this.desconto > ((this.dados.quantidade - 1) * this.dados.produto.valor)) {
        //   this.$swal("Atenção","Para diminuir a quantidade, remova o desconto.");
        //   return;
        // }

        if (p.quantidade > 1) {
          p.quantidade--;

        } else {
          this.removerProduto(p, index);
        }

        this.totalizarProduto(p);
      },

      alterarPeso(p) {
        if (p.valor_total > 0) {
          p.quantidade = (p.valor_total / p.produto.valor).toFixed(3);

        } else {
          p.quantidade = '0.000';
          p.valor_total = '0.00';
          this.$swal('Informe uma quantidade válida');
        }
      },

      totalizarProduto(p) {
        let valor = parseFloat(p.produto.valor);

        if (p.divisoes.length > 0) {
          valor = p.produto.tipo_venda === '2' ?
              (p.divisoes.map(d => parseFloat(d.valor)).reduce((prev, curr) => prev + curr, 0) / p.divisoes.length)
              : Math.max.apply(Math, p.divisoes.map(d => { return d.valor; }));
        }

        let valorAdicionais = 0;
        p.adicionais.forEach((a) => {
          valorAdicionais += a.valor * a.quantidade
        });

        p.valor_total = ((valor + valorAdicionais) * p.quantidade) - p.desconto;
        this.totalizar()
      },

      nextPedido() {
        this.$helpers.focusElement(this.comanda.tipo_comanda === '2' ? 'btnEntregar' : 'btnConsumo');
      },

      addVoucher(voucher, desconto, valor) {
        this.termo = "";

        if (!this.modal) {
          this.toggleModal(true);
        }

        if (this.dados.pagamentos.find(pag => pag.id_voucher === voucher.id_voucher)) {
          this.$swal("Voucher já adicionado no pedido!");
          return false;
        }

        if (desconto && !this.validarPedidoProduto(voucher.id_tabela_preco)) {
          this.$swal(`Para adicionar este Voucher você precisa ter o produto: *${voucher.titulo}*, adicionado neste pedido.`);
          return false;
        }

        this.dados.pagamentos.push({
          id_pagamento: '21',
          id_voucher: voucher.id_voucher,
          id_tabela_preco: voucher.id_tabela_preco,
          observacao: `${voucher.ref_voucher} - ${voucher.titulo}`,
          valor: valor || voucher.valor
        });

        return true;
      },

      validarPedidoProduto(id_tabela_preco) {
        if (this.dados.produtos.find(p => p.id_tabela_preco === id_tabela_preco)) {
          return true;
        }

        for (let i=0; i < this.dados.produtos.length; i++) {
          let produto = this.dados.produtos[i];

          if (!!produto.adicionais.find(a => a.id_tabela_preco === id_tabela_preco) || !!produto.divisoes.find(d => d.id_tabela_preco === id_tabela_preco)) {
            return true;
          }
        }

        return false;
      },

      changeQtdPessoas(qtd) {
        if (qtd) {
          let qtd_p = parseInt(this.qtd_pessoas || '1');

          if ((qtd_p + qtd) > 0) {
            this.qtd_pessoas = qtd_p + qtd;
          }

        } else if (isNaN(this.qtd_pessoas) || parseInt(this.qtd_pessoas) < 1) {
          this.qtd_pessoas = 1;

        } else if (parseInt(this.qtd_pessoas) > 256) {
          this.qtd_pessoas = 256;
        }
      },

      openModaComandas() {
        this.term_comanda = '';
        this.comandasBd = [];
        this.comandas = [];
        this.load = true;
        this.modalComandas = true;

        this.$http.get('comandas/mesas/' + this.token, { params: { tipo: 3 } })
          .then(response => {
            this.comandasBd = response.data || [];

            for (let i=1; i <= parseInt(this.$store.state.pdv.qtd_comandas); i++) {
              if (!this.comandasBd.find(c => parseInt(c.ref_comanda) === i)) {
                this.comandas.push(i);
              }
            }

            this.load = false;

            this.$nextTick(() => {
              this.$helpers.focusElement('termComanda');
            });

          }, res => {
            console.log(res);
            this.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      selComanda(ref) {
        if (ref && !isNaN(ref)) {
          if (this.comandasBd.find(c => c.ref_comanda == ref)) {
            this.$swal("A comanda informada não está disponível!");
            return;
          }

          this.ref_comanda = ref;
          this.modalComandas = false;
          this.$nextTick(() => {
            this.$helpers.focusElement('obsComanda');
          })
        }
      },

      abrirPedido(termo) {
        this.editar = false;

        if (this.modal) {
          return;
        }

        if (this.comanda.tipo_comanda === '4') {
          this.$swal('Venda rápida não permite criação de pedido.');
          return;
        }

        this.limparPedido();
        this.dados.tipo_pedido = this.comanda.tipo_comanda === '2' ? '1' : '3';
        const isNumero = (termo.valor && !isNaN(termo.valor));
        this.pesquisarProduto(termo, isNumero, 'pesquisar');
      },

      closeModals() {
        this.modal = null;
        this.$helpers.toggleModal(null);
        this.$refs.pedidoPesquisa.closePesquisar();
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      configs() {
        return this.$store.state.pdv.json_config;
      },

      local() {
        return this.$store.state.configsLocal;
      },

      id_catalogo() {
        return this.$store.state.id_catalogo;
      },

      print_auto() {
        return this.$store.state.pdv.automatico;
      },

      impressora() {
        return this.$store.state.impressora
      },

      configImpressao() {
        return this.$store.state.configImpressao;
      },

      usaNovaImpressao() {
        return Number(this.configImpressao.migrado_legado || 0) === 1;
      },

      printServer() {
        return this.$store.state.printServer;
      },
    },

    filters: {
      valor(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(2);
        }
      },

      medida(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed(3) + " kg";
        }
      },

      qtdAdc(value) {
        let qtd = parseFloat(value && !isNaN(value) ? value : '1');
        return qtd > 1 ? (qtd.toFixed() + 'x') : '';
      }
    }

  }
</script>

<style scoped>
  .pdivisoes:after {
    content: ' / ';
    font-weight: bold;
  }

  .pdivisoes:last-child:after {
    content: '';
  }

  .r-pedido {
    width: 55px;
  }

  @media (max-width: 993px) {
    .r-pedido {
      width: 35px;
    }

    .lista-comandas {
      margin-bottom: 82px;
    }
  }

</style>
